import { useNavigate } from "react-router-dom";

const MembershipPricingBanner = () => {
  const navigate = useNavigate();

  return (
    <section className="py-14 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-amber-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-building-2-line text-amber-700 text-sm"></i>
            <span className="text-amber-800 text-xs font-bold uppercase tracking-widest">Factory &amp; Local Warehouse Membership</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            List Your Factory — Start Free, Grow Without Risk
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto">
            Verified factories and local warehouses get full platform access to reach global stars and buyers worldwide.
            First 3 months completely free — no credit card needed.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
          {/* Free Plan */}
          <div className="relative rounded-2xl border-2 border-amber-400 bg-gradient-to-br from-amber-50 to-yellow-50 p-7">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2">
              <span className="bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                First 3 Months FREE
              </span>
            </div>
            <div className="text-center mb-6 pt-2">
              <div
                className="text-5xl font-black text-amber-700 mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                $0
              </div>
              <div className="text-gray-500 text-sm">for the first 3 months</div>
            </div>
            <ul className="space-y-3 text-sm text-gray-700">
              {[
                "Full verified factory listing",
                "Connect with global stars & influencers",
                "Local warehouse drop shipping enabled",
                "Real-time sales & order tracking",
                "No credit card required",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-amber-200 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-amber-800 text-xs"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Paid Plan */}
          <div className="rounded-2xl border-2 border-gray-200 bg-white p-7">
            <div className="text-center mb-6">
              <div
                className="text-5xl font-black text-gray-900 mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                $5<span className="text-xl font-semibold text-gray-400">/mo</span>
              </div>
              <div className="text-gray-500 text-sm">after the free trial period</div>
            </div>
            <ul className="space-y-3 text-sm text-gray-700">
              {[
                "Everything in the free plan",
                "Priority placement in search results",
                "Unlimited product listings",
                "Advanced analytics & reports",
                "Dedicated account support",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-gray-600 text-xs"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* CTA + Note */}
        <div className="text-center">
          <div className="inline-flex flex-col items-center gap-3">
            <button
              onClick={() => navigate("/register-factory")}
              className="bg-amber-500 hover:bg-amber-600 text-white font-bold px-12 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-3 text-base"
              style={{ boxShadow: "0 4px 24px rgba(245,180,0,0.25)" }}
            >
              <i className="ri-building-4-line text-lg"></i>
              Register Your Factory — Free for 3 Months
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <div className="flex items-center gap-4 text-xs text-gray-400">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-amber-500"></i>
                No credit card needed
              </span>
              <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line text-amber-500"></i>
                3 months free
              </span>
              <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
              <span className="flex items-center gap-1">
                <i className="ri-money-dollar-circle-line text-amber-500"></i>
                Only $5/mo after trial
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipPricingBanner;
